module.exports = (__webpack_require__(704259))(2505);